import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["onBackClick", "hideTrustBuilders"];
import { Box, Heading, Text } from '@wix/design-system';
import React from 'react';
import { Groups, LockLocked, WixForum } from '@wix/wix-ui-icons-common/lazy';
import { HeaderWrapper } from '../HeaderWrapper';
import s from './AnonymousResultsHeader.scss';
import { DomainSearchGateModule } from '../../../module/domainSearchGate.module';
import { useIsMobile } from '../../../hooks/useIsMobile';
const TrustBuilderItem = _ref => {
  let icon = _ref.icon,
    text = _ref.text;
  return /*#__PURE__*/React.createElement(Box, {
    gap: "SP1",
    verticalAlign: "middle"
  }, icon, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "normal"
  }, text));
};
export const Base44ResultsHeader = _ref2 => {
  let onBackClick = _ref2.onBackClick,
    _ref2$hideTrustBuilde = _ref2.hideTrustBuilders,
    hideTrustBuilders = _ref2$hideTrustBuilde === void 0 ? false : _ref2$hideTrustBuilde,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded);
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const isMobile = useIsMobile();
  const title = /*#__PURE__*/React.createElement(Heading, {
    size: "large",
    className: s.resultsHeaderTitle
  }, t('domains_search_gate.base44.gate.results.title'));
  if (isMobile) {
    return /*#__PURE__*/React.createElement(Box, _extends({
      align: "center",
      textAlign: "center",
      width: "100%"
    }, props), title);
  }
  const trustBuilders = [{
    icon: /*#__PURE__*/React.createElement(Groups, {
      size: "18px"
    }),
    translationKey: 'domains_search_gate.base44.gate.results.trustbuilder.users'
  }, {
    icon: /*#__PURE__*/React.createElement(LockLocked, {
      size: "18px"
    }),
    translationKey: 'domains_search_gate.base44.gate.results.trustbuilder.ssl'
  }, {
    icon: /*#__PURE__*/React.createElement(WixForum, {
      size: "18px"
    }),
    translationKey: 'domains_search_gate.base44.gate.results.trustbuilder.support'
  }];
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "100%",
    gap: "SP3",
    marginBottom: "SP1"
  }, /*#__PURE__*/React.createElement(HeaderWrapper, _extends({
    onBackClick: onBackClick
  }, props), title), !hideTrustBuilders && /*#__PURE__*/React.createElement(Box, {
    gap: "SP6",
    align: "center",
    verticalAlign: "middle",
    className: s.whyWixBenefits
  }, trustBuilders.map(_ref3 => {
    let icon = _ref3.icon,
      translationKey = _ref3.translationKey;
    return /*#__PURE__*/React.createElement(TrustBuilderItem, {
      key: translationKey,
      icon: icon,
      text: t(translationKey)
    });
  })));
};
//# sourceMappingURL=Base44ResultsHeader.js.map